import React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { TimePicker } from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import { settheGrievenceGetListForTYPEEMpActions, SetCreateGrievanceApplyEmpAction } from "../../../../../../Redux/Slice";
import Select from "react-select";

function GrievanceApplyEmp(props) {
    const {
        show,
        setShow,
        editPayload,
        refresh,
        selectedPerformanceId,
        setEditPayload,
        GetFilter,
        page,
        status,
        search

    } = props;
    const state = useSelector((state) => state);

    const [value, setValue] = useState();
    const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

    const userId = useSelector(
        (state) => state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data.id
    );
    const [searchvalues, setsearch] = useState("")
    const [data, setData] = useState({
        grievance_type: "",
        user_id: userId,
        purpose: "",
        request_type: "request"
    });
    const [fieldErrors, setFieldErrors] = useState({
        purpose: "",
        grievance_type: "",
    });
    const [editMode, setEditMode] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [Options, setOptions4] = useState()
    const [GrievanceValues, setGrievanceValue] = useState([])
    const dispatch = useDispatch();
    useEffect(() => {
        const payload = {
            search: searchvalues,
            page_size: 20,
            page: 1,

        }
        dispatch(settheGrievenceGetListForTYPEEMpActions(payload))
    }, [searchvalues])
console.log(GetFilter ,"aosi GetFilter");

    useEffect(() => {
        if (state.grievenceTypeDatasEmp.grievenceTypeDatasForEmployee != undefined) {
            let objectArray = [];
            state.grievenceTypeDatasEmp.grievenceTypeDatasForEmployee.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.grievance_type,
                });
            });
            setOptions4(objectArray);
        }
    }, [state.grievenceTypeDatasEmp.grievenceTypeDatasForEmployee, searchvalues]);

    console.log(GetFilter ,"asdsd GetFilter");
    
    const handleError = () => {
        const newFieldErrors = {};
        Object.entries(data).forEach(([key, value]) => {
            if (key === "grievance_type" && value.length === 0) {
                newFieldErrors[key] = "Type must not be empty.";
            } else if (key === "purpose" && value.length === 0) {
                newFieldErrors[key] = "Purpose must not be empty.";
            } else {
                newFieldErrors[key] = "";
            }
        });
        const hasError = Object.values(newFieldErrors).some((error) => error);
        setFieldErrors(newFieldErrors);
        if (!hasError) {
            const payload = {
                data: {
                    grievance_type: data.grievance_type,
                    purpose: data.purpose,
                    user_id: userId,
                    request_type: "request",
                },
                GetFilters: GetFilter,
                Requesttype: 1,
                page:page ,
                status:status,
                search :search

            }
            dispatch(SetCreateGrievanceApplyEmpAction(payload));
            setEditPayload("");
            setData({
                purpose: "",
                grievance_type: "",
                user_id: "",
            });
            setFieldErrors({
                purpose: "",
                grievance_type: "",
            });
            setShow(false);
        }
    };
    const handleSubmit = () => {
        handleError();
    };
    const handleClose = () => {
        setEditPayload("");
        setShow(false);

        setData({
            purpose: "",
            grievance_type: "",

        });
        setFieldErrors({
            purpose: "",
            grievance_type: "",

        });
    };

    const handleDate = (inputDate, name) => {
        setFieldErrors((prev) => {
            return {
                ...prev,
                [name]: "",
            };
        });
    };
    const HandletheChnages = (val) => {
        setsearch(val)
    }
    const HandleTheTypeChanges = (val) => {
        setGrievanceValue(val)
        setData({
            ...data,
            grievance_type: val.value
        })
        setFieldErrors((prev) => ({
            ...prev,
            grievance_type: "",
        }));
    }

    return (
        <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={handleClose}
            className="modelman"
            size="lg"
            backdrop="static"
        >
            <Modal.Header className="popHead">
                <Modal.Title>
                    {Object.entries(editPayload).length > 0
                        ? "Grievance Apply"
                        : "Grievance Apply"}
                </Modal.Title>
                <div className="CloseIcon" onClick={handleClose}>
                    <CloseOutlinedIcon />
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    <label className="col-12 p-0" htmlFor="leaveDate">
                        Type <span style={{ color: "red" }}>*</span>
                    </label>
                </div>
                <Select
                    className="Selects"
                    styles={{ position: "relative", top: "60px" }}
                    onInputChange={HandletheChnages}
                    options={Options}
                    onChange={HandleTheTypeChanges}
                    value={GrievanceValues}
                />
                {fieldErrors.grievance_type && (
                    <div
                        className="error"
                        style={{
                            color: "red",
                            height: "20px",
                            padding: "5px",
                        }}
                    >
                        {fieldErrors.grievance_type}
                        <span style={{ color: "red" }}>*</span>
                    </div>
                )}


                <div className="row ">
                    <div className="col-12 section1">
                        <label
                            className="mt-4 mb-4"
                            htmlFor="leaveDate"
                            style={{ margin: "0" }}
                        >
                            {" "}
                            Purpose<span style={{ color: "red" }}>*</span>
                        </label>
                    </div>
                    <div className="col-12 section1">
                        <textarea
                            style={{
                                width: "100%",
                                height: "200px",
                                border: "1px solid lightgrey",
                                padding: "11px"
                            }}
                            value={data.purpose}
                            onChange={(e) => {
                                setFieldErrors((prev) => ({
                                    ...prev,
                                    purpose: "",
                                }));
                                setData((prev) => ({
                                    ...prev,
                                    purpose: e.target.value,
                                }));
                            }}
                        />
                        {fieldErrors.purpose && (
                            <div
                                className="error"
                                style={{
                                    color: "red",
                                    height: "20px",
                                    padding: "5px",
                                }}
                            >
                                {fieldErrors.purpose}
                                <span style={{ color: "red" }}>*</span>
                            </div>
                        )}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="RoleButton">

                    <button class="btn CancelBtn" onClick={handleClose}>
                        Cancel
                    </button>
                    <button
                        class="CancelBtn btn"
                        type="submit"
                        onClick={(e) => {
                            handleSubmit();
                        }}
                        style={{ marginBottom: "20px", background: "#234492", color: "white" }}

                    >
                        Submit
                    </button>

                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default GrievanceApplyEmp;